import { ReactElement } from 'react'
import FooterTemplate from './template'

const FooterPage = (): ReactElement => {
    return <FooterTemplate />
}

export default FooterPage
